import { render, staticRenderFns } from "./ViewRotate.vue?vue&type=template&id=0076fa6a&scoped=true&"
import script from "./ViewRotate.vue?vue&type=script&lang=js&"
export * from "./ViewRotate.vue?vue&type=script&lang=js&"
import style0 from "./ViewRotate.vue?vue&type=style&index=0&id=0076fa6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0076fa6a",
  null
  
)

export default component.exports